import {
  GET_USER_DETAILS_REQUEST,
  GET_USER_DETAILS_RESPONSE,
  UPDATE_USER_STATUS_BY_USER_ID_REQUEST,
  UPDATE_USER_STATUS_BY_USER_ID_RESPONSE,
} from "./actionTypes";

export const getUserDetailsRequest = () => {
  return {
    type: GET_USER_DETAILS_REQUEST,
  };
};

export const getUserDetailsResponse = (apiResponse) => {
  return {
    type: GET_USER_DETAILS_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateUserStatusByUserIdRequest = (userId, status) => {
  return {
    type: UPDATE_USER_STATUS_BY_USER_ID_REQUEST,
    payload: { userId, status },
  };
};

export const updateUserStatusByUserIdResponse = (apiResponse) => {
  return {
    type: UPDATE_USER_STATUS_BY_USER_ID_RESPONSE,
    payload: { apiResponse },
  };
};
